export default "__VITE_ASSET__1mXAJbUA__"